// extracted by mini-css-extract-plugin
module.exports =  {"container":"_0bc5e8de02--container--eix2i","name":"_0bc5e8de02--name--VQ5Xh","phone":"_0bc5e8de02--phone--NDJyi","note":"_0bc5e8de02--note--LoOKS"};